import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import CustomButton from "../CustomButton";
import { useDispatch } from "react-redux";
import { isAndroid, isIOS } from "react-device-detect";
import { useNavigate } from "react-router";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import {
  setAppAlert,
  setCustomModal,
  setModalType,
} from "../../../redux/features/settingSlice";
import CustomCard from "./../CustomCard/index";
import GooglePlay from "../../../media/svg/GooglePlay";

const AppAlertBox = ({ icon }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const xWidth = useMediaQuery("(min-width:370px)");

  const handleAppAlert = () => {
    dispatch(setAppAlert(false));
  };

  const handleHomeScreenModal = () => {
    if (isIOS) {
      dispatch(setCustomModal(true));
      dispatch(setModalType("Azad"));
    }

    if (isAndroid) {
      navigate("/application");
    }
  };
  return (
    <CustomCard
      pSize={16}
      shadowSize={icon ? 0 : 2}
      radius={16}
      maxHeight={256}
      mTop={8}
      mBottom={16}
    >
      <Typography
        sx={{ fontSize: "18px", fontWeight: 600, lineHeight: "28px" }}
      >
        Enjoy a better experience
      </Typography>
      <Box sx={{ display: "flex" }}>
        <ErrorOutlineOutlinedIcon sx={{ mr: "8px" }} />

        <Typography sx={{ fontSize: "14px", lineHeight: "20px" }}>
          {isIOS
            ? "Add to Home Screen helps us making Azad more convenient for you."
            : "Installing the app on your device helps us making Azad more convenient for you."}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContreplent: "space-between",
          mt: "12px",
        }}
      >
        <CustomButton
          title='Maybe later'
          onClick={handleAppAlert}
          fSize={xWidth ? "14px" : "12px"}
          width='100%'
          height='34px'
          bShadow='0px'
          bgColor='white.main'
          mRight='16px'
        />

        <CustomButton
          title={isIOS ? "Add to home" : "Install Azad app"}
          onClick={handleHomeScreenModal}
          icon1={isIOS ? null : <GooglePlay />}
          fSize={xWidth ? "14px" : "12px"}
          width='100%'
          height='34px'
          bShadow='2px'
          bgColor='primary.main'
          justify='center'
        />
      </Box>
    </CustomCard>
  );
};

export default AppAlertBox;
